import * as React from "react";
import { forwardRef } from "react";
const SvgImport = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.271 18H.735V0h15.069v6.769h-1.535V1.536h-12v14.931h12v-5.234h1.535V18zm-.79-7.1L5.581 9l1.884-1.884c1.031-1.031 1.9-1.885 1.921-1.885s.276.247.569.54l.544.544-.956.955-.961.962h8.686v1.535H8.582l.961.965.956.955-.557.557-.557.56z", "data-name": "icon_import" }));
const ForwardRef = forwardRef(SvgImport);
export { ForwardRef as ReactComponent };
